export default class passwordRuleCheck {

    private responseContainer: HTMLInputElement;
    private passwordInputs: HTMLCollectionOf<Element>;
    private input: HTMLInputElement;
    private passwordErrorFlag: boolean;
    constructor() {
        this.responseContainer = document.getElementById('password-validation-container') as HTMLInputElement;

        if (typeof this.responseContainer === 'undefined')  {
            return;
        }

        this.input = document.getElementsByName('new_password')[0] as HTMLInputElement;
        if (typeof this.input === 'undefined') {
            this.input = document.getElementsByName('password')[0] as HTMLInputElement;
        }

        this.passwordErrorFlag = false;
        this.passwordInputs = document.getElementsByClassName('form-input-password') as HTMLCollectionOf<HTMLElement>;
        if (this.passwordInputs.length == 0) {
            this.passwordInputs = document.getElementsByClassName('log-in-widget__form__item') as HTMLCollectionOf<HTMLElement>;
        }
        Array.from(this.passwordInputs).forEach((item) => {
            let errors = item.getElementsByClassName('form-input-error') as HTMLCollectionOf<HTMLElement>
            if (errors.length) {
                Array.from(errors).forEach((error) => {
                    if (error.innerHTML == "Your password doesn't meet the strength requirements.") {
                        error.hidden = true;
                    }
                    if (error.innerHTML == "The new password must be at least 12 characters.") {
                        error.hidden = true;
                    }
                })
                this.output()
                this.passwordErrorFlag = true;
                this.responseContainer.hidden = !this.passwordErrorFlag
            }
        },this)

        this.input.addEventListener('input', (event) => {
            this.responseContainer.hidden = !this.input.value;
            this.input.setCustomValidity('');
            this.output()
        });

        const form = this.input?.closest('form');
        if (form) {
            form.addEventListener('submit', (event) => this.checkWafCanary(event));
        }
    }

    private checkWafCanary(event: Event): void {
        const password = this.input.value;

        if (!password) {
            return;
        }

        event.preventDefault();
        const form = event.target as HTMLFormElement;

        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';

        fetch(
            '/waf-canary',
            {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                },
                body: new URLSearchParams({ password }),
            }
            )
            .then((response) => {
                if (response.ok) {
                    form.submit();
                } else {
                    this.input.setCustomValidity('Please choose a different password.');
                    this.input.reportValidity();
                }
            })
            .catch(() => {
                this.input.setCustomValidity('Please choose a different password.');
                this.input.reportValidity();
            });
    }

    output () : void {
        const checkIcon = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        const xIcon = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        let rules = {
            'upper': {
                'state': !!this.input.value.match('[A-Z]'),
                'text': 'An uppercase letter',
            },
            'lower': {
                'state': !!this.input.value.match('[a-z]'),
                'text': 'A lowercase letter',
            },
            'number': {
                'state': !!this.input.value.match('[0-9]' ),
                'text': 'A number',
            },
            'symbol': {
                'state': !!this.input.value.match(/[\p{Z}\p{S}\p{P}]/u),
                'text': 'A symbol',
            },
        };

        const lengthValid = this.input.value.length >= 12;

        let rulesPassCount = 0;
        Object.keys(rules).forEach(key => {
            if (rules[key].state) {
                rulesPassCount++;
            }
        });
        const rulesValid = rulesPassCount >= 4;

        let output = '';

        // Length requirement
        output += `<div class="myae-log-in__validation-item ${lengthValid ? 'myae-log-in__validation-item--valid' : 'myae-log-in__validation-item--invalid'}">`;
        output += lengthValid ? checkIcon : xIcon;
        output += '<span>Your password should be 12 characters or more.</span></div>';

        // Character types heading
        output += `<div class="myae-log-in__validation-heading">`;
        output += rulesValid ? checkIcon : xIcon;
        output += '<span>Your password must contain at least one of each character type:</span></div>';

        // Individual character type rules
        Object.keys(rules).forEach(key => {
            const valid = rules[key].state;
            output += `<div class="myae-log-in__validation-item ${valid ? 'myae-log-in__validation-item--valid' : 'myae-log-in__validation-item--invalid'}" style="padding-left: 35px;">`;
            output += valid ? checkIcon : xIcon;
            output += `<span>${rules[key].text}</span></div>`;
        });

        this.responseContainer.innerHTML = output;
    }
}

